import * as XLSX from 'xlsx';
import fileDownload from 'js-file-download';

const exportToExcelFile = (data, title) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  fileDownload(blob, `${title}.xlsx`);
};

// Several sheets in one file: [{ name, rows: [{ column: value }] }]
export const exportSheetsToExcelFile = (sheets, title) => {
  const workbook = XLSX.utils.book_new();
  sheets.forEach(({ name, rows }) => {
    // Excel allows at most 31 characters in a sheet name
    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.json_to_sheet(rows),
      `${name}`.slice(0, 31)
    );
  });
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  fileDownload(blob, `${title}.xlsx`);
};

export default exportToExcelFile;
